import { render, staticRenderFns } from "./BuKundenHerstellerUmsaetzeReiter.vue?vue&type=template&id=cee12b24&"
import script from "./BuKundenHerstellerUmsaetzeReiter.vue?vue&type=script&lang=js&"
export * from "./BuKundenHerstellerUmsaetzeReiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports